// extracted by mini-css-extract-plugin
module.exports = {"descriptionDetailContainer":"DescriptionDetails_descriptionDetailContainer__3WB_D","tabCardContainer":"DescriptionDetails_tabCardContainer__1h7Bc"};